
import EusButton             from "components/Button/EusButton"
import styled                from "styled-components"
import OpenhouseInfo         from "./OpenhouseInfo"
import { EventCalendar }     from "components/Calendar/EventCalendar"
import dayjs                 from "dayjs"
import { Box }               from "@mui/material"
import { ReactSelect }       from "components/AdvanceDropdown/NormalDropdown/Dropdown"
import { getFocus, useAtom } from "state/jotai"
import { _bootstrap }        from "state/store.bootstrap"
import { current_language }  from "state/store.global"
import { useEffect, useState }         from "react"

const Container = ({ step, setStep }) => {
    const [property, setProperty]           = useState({})
    const [selectedEvent, setSelectedEvent] = useState(dayjs(new Date()))
    const [eDates, setEdates]               = useState(['2024-06-01', '2024-06-15', '2024-07-01'])

    const dropdownOption = getFocus(_bootstrap, "projectnames");
    const language       = useAtom(current_language)[0];


    useEffect(()=> {
        if(Object.keys(dropdownOption || {}).length) {
        const prp       = dropdownOption[language]?.[0]
        const initalPrp = {
            value: prp?.URLSafe,
            label: prp?.Presentation,
            dpin : prp?.PIN,
            dpid : prp?.PID,
        
        }
        
        setProperty(initalPrp)
        }
    }, [dropdownOption])



  return (
    <Section>
            <Topinfo>
                <Heading>
                    <div className = "h3">Begivenheder i Travbyen</div>
                    <div className = "paragraph1-regular">Her er de næst kommende begivenheder som afholdes på Travbyen. Klik på en begivenhed herunder for at læse detaljerne.</div>
                </Heading>

                <PropertyButtons>
                    <Button />
                    <Button />
                    <Button />
                    <Button />
                </PropertyButtons>
            </Topinfo>

            <BottomInfo>
                <Box sx        = {{ display: 'flex', flexDirection: 'column', gap: '16px', marginBottom: '24px' }}>
                <Box sx        = {{ display: 'flex', flexDirection: 'column', gap: '4px', maxWidth: '592px', width: '100%' }}>
                <div className = "paragraph-regualar">
                            Det er også muligt at se hvilke begivenheder, der er planlagt på en bestemt ejendom.
                        </div>
                        <div className = "paragraph-regualar">
                            Vælg hvilken ejendom du ønsker at se planlagte begivenheder på.
                        </div>
                    </Box>
                    <div>
                        <Box         sx        = {{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                        <div         className = "h4">Vælg ejendom</div>
                        <ReactSelect options   = {dropdownOption[language].map(({ Presentation, URLSafe, PID, PIN }) => ({
                                                value: URLSafe,
                                                label: Presentation,
                                                dpin : PIN,
                                                dpid : PID,
                                                }))}
                                                value    = {property}
                                                onChange = {(e) => {
                                                setProperty(e);
                                                }} />
                        </Box>
                    </div>
                </Box>
                <Box           sx            = {{ marginBottom: '16px' }} className = "h4">Find begivenhed</Box>
                <Box           sx            = {{ display: 'flex', alignItems: 'center', gap: '40px' }}>
                <EventCalendar selectedEvent = {selectedEvent} setSelectedEvent     = {setSelectedEvent} eventData = {eDates} />
                    <OpenhouseInfo />
                </Box>
            </BottomInfo>

            <EusButton
                icon        = {true}
                clr         = {clr}
                buttonlabel = {false}
                otherText   = {"Tilmeld dig denne begivenhed"}
                onClick     = {() => { setStep(2) }}
                variant     = {"primary"}
                iconSize    = {"xl"}
                width       = {"max-content"}
                padding     = {"15px 30px"}
            />
        </Section>
  )
}

export default Container


const Section = styled.div`
  background-color: #F8F9F1;
  padding         : 16px 24px;
      max-height       : calc(100vh - 316px);
      height          : 100%;
  overflow-y: auto;
`


const Heading = styled.div`
    display       : flex;
    flex-direction: column;
    gap           : 16px;
`

const Topinfo = styled.div`
    display       : flex;
    flex-direction: column;
    gap           : 24px;
    margin-bottom : 40px;
`
const BottomInfo = styled.div`
    display       : flex;
    flex-direction: column;
    margin-bottom : 24px;
`

const PropertyButtons = styled.div`
    display  : flex;
    gap      : 24px;
    flex-wrap: wrap;
`

const Button      = () => <EusButton
      iconName    = {"calender-check"}
      icon        = {true}
      clr         = {clr}
      buttonlabel = {false}
      otherText   = {"Ønsker du?"}
      onClick     = {() => {}}
      variant     = {"primary"}
      iconSize    = {"xl"}
      width       = {"max-content"}
      isFaIcon    = {true}
      padding     = {"15px 30px"}
            />

